import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

const WIDTH = { '2xl': 'max-w-2xl', '3xl': 'max-w-3xl', '4xl': 'max-w-4xl', '5xl': 'max-w-5xl', '6xl': 'max-w-6xl' } as const;

export type PageWidth = keyof typeof WIDTH;

/** Route-level wrapper: centred max width, original page padding and page-enter animation. */
export function Page({ width, className, children }: { width: PageWidth; className?: string; children: ReactNode }): JSX.Element {
  return <div className={cn('mx-auto w-full p-4 animate-page-in sm:p-6', WIDTH[width], className)}>{children}</div>;
}
